import { styled } from '@mui/material/styles';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import { MdArrowForwardIos as ArrowForwardIosSharpIcon } from 'react-icons/md';
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionActions from '@mui/material/AccordionActions';

const StyledAccordion = styled((props: AccordionProps) => (
  <MuiAccordion
    TransitionProps={{ unmountOnExit: true, mountOnEnter: false }}
    disableGutters
    {...props}
  />
))(({ theme }) => ({
  width: '100%',
  borderTopLeftRadius: 'unset !important',
  borderTopRightRadius: 'unset !important',
  borderBottomLeftRadius: 'unset !important',
  borderBottomRightRadius: 'unset !important',
  borderWidth: 1,
  borderBottom: `1px solid rgba(255, 255, 255, 0.12)`,
}));

export const StyledAccordionDetails = styled(MuiAccordionDetails)(
  ({ theme }) => ({
    paddingInlineStart: theme.spacing(3),
    paddingBlockStart: theme.spacing(2),
    paddingBlockEnd: theme.spacing(1),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
  }),
);

export const StyledAccordionActions = styled(MuiAccordionActions)(
  ({ theme }) => ({
    border: 0,
    paddingLeft: theme.spacing(2.5),
    paddingBlockStart: theme.spacing(1),
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
  }),
);

export const StyledAccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon style={{ fontSize: '0.5rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
  '&:hover': {
    background:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.1)'
        : 'rgba(0, 0, 0, 0.04)',
  },
}));

export default StyledAccordion;
